<template>
  <label class="checkbox" :class="{ disabled }">
    <input type="checkbox" :checked="modelValue" :disabled="disabled" @change="onChange" />

    <div v-if="imageUrl" class="icon-wrap">
      <img :src="imageUrl" alt="image" />
    </div>

    <p v-if="$slots.default">
      <slot />
    </p>
  </label>
</template>

<script setup lang="ts">
const modelValue = defineModel({
  default: false,
});

withDefaults(
  defineProps<{
    disabled?: boolean;
    imageUrl?: string;
  }>(),
  {
    disabled: false,
    imageUrl: '',
  }
);

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void;
}>();

const onChange = (e: Event) => {
  const target = e.target as HTMLInputElement;
  emit('update:modelValue', target.checked);
};
</script>

<style lang="scss" scoped>
.checkbox {
  display: flex;
  flex: 1;
  border: 1px solid $color-gray-40;
  padding: $spacing3 0;
  border-radius: $spacing2;
  flex-direction: column;
  align-items: center;
  .icon-wrap {
    width: 2.5rem;
    height: 2.5rem;
    background: $color-gray-10;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  p {
    font-weight: 500;
  }
  &:has(input:checked) {
    border: 1px solid $color-navy-100;
    background: $color-navy-5;
    .icon-wrap {
      background: #fff;
    }
    p {
      color: $color-navy-100;
    }
  }
}
</style>
